import { createCRUDHook } from './createCRUDHook';
import { TimeClockNoticeDto } from 'utils/models';
import { TBL_NOTICE } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<TimeClockNoticeDto>(
  {
    entityName: 'TimeClockNotices',
    endpoint: TBL_NOTICE,
  }
);

export const TimeClockNoticesContext = Context;
export const useTimeClockNoticesManager = useManager;
export const useTimeClockNotices = useConsumer;
